<div class="bg-white fixed flex flex-auto flex-col h-full items-center left-0 min-w-0 sm:justify-center top-0 w-full bg-opacity-90"
    style="z-index: 9999999999;">
    <div class="w-full sm:w-auto py-8 px-4 sm:p-12">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <div class="px-5 mx-auto w-full flex justify-center">
                <img class="w-50" src="assets/images/logo_silvestre/GS-2-sin-back.png">
            </div>

            <div
                class="mt-8 flex justify-center text-md font-bold text-primary-500 tracking-tight leading-tight text-center">
                <mat-spinner [diameter]="25"></mat-spinner>
            </div>
        </div>
    </div>
</div>
